import React from "react";
import { connect } from "react-redux";
import { LOGIN, REGISTER } from "../constants/actionTypes";
import { Masks, Activities, Office } from "../constants/enums";
import * as agent from "../agent";
import { required, validateEmail, validatePhone } from "../utility";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { MaterialTextField, MaterialMaskedTextField } from "./MaterialInput";
import SubmitButton from './SubmitButton';
import SwipeableViews from 'react-swipeable-views';
import Collapse from '@material-ui/core/Collapse';
import Fade from '@material-ui/core/Fade';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import FaceIcon from '@material-ui/icons/Face';

class registerForm extends React.Component {

    state = {
        extended: false,
        personType: "NATURAL_PERSON"
    };

    toggleExtended = () => {
        const { extended } = this.state;
        this.setState({ extended: !extended, personType: "NATURAL_PERSON" });
    }

    togglePersonType = (e) => this.setState({ personType: e.target.value });

    render() {
        const { handleSubmit } = this.props;
        const { extended, personType } = this.state;
        return (
            <form className="common-form" onSubmit={handleSubmit} autoComplete="off">
                <Field component={MaterialTextField}
                       name="email"
                       validate={validateEmail}
                       label="Электронный адрес" />
                <Field component={MaterialTextField}
                       name="password"
                       validate={required}
                       type="password"
                       label="Пароль" />
                <Field name="fullname"
                       validate={required}
                       component={MaterialTextField}
                       label="ФИО" />
                <Field name="phone"
                       component={MaterialMaskedTextField}
                       mask={Masks.phone}
                       validate={validatePhone}
                       placeholder="+7 (___) ___-__-__"
                       label="Номер телефона" />
                <Field name="office"
                            select
                            validate={required}
                            component={MaterialTextField}
                            label="Офис" >
                        { Object.keys(Office).map(o => <MenuItem value={o}>{ Office[o] }</MenuItem>) }
                </Field>
                <FormControlLabel label="Подробная форма"
                                  control={<Switch checked={extended} color="secondary" onChange={this.toggleExtended} />} />
                <Collapse in={extended} classes={{ container: "collapse-wrapper", wrapperInner: "common-form" }}>
                    <Field name="pasport.serial"
                           component={MaterialMaskedTextField}
                           mask={Masks.passport}
                           label="Серия и номер паспорта" />
                    <Field name="pasport.date"
                           component={MaterialMaskedTextField}
                           mask={Masks.date}
                           label="Дата выдачи паспорта" />
                    <Field name="type"
                           select
                           component={MaterialTextField}
                           onChange={this.togglePersonType}
                           label="Правовой статус" >
                        <MenuItem value="NATURAL_PERSON" >Физическое лицо</MenuItem>
                        <MenuItem value="JURIDICAL_PERSON" >Юридическое лицо</MenuItem>
                    </Field>
                    <Collapse in={personType === "JURIDICAL_PERSON"} classes={{ container: "collapse-wrapper", wrapperInner: "common-form" }}>
                        <Field name="org.phone"
                               mask={Masks.phone}
                               placeholder="+7 (___) ___-__-__"
                               component={MaterialMaskedTextField}
                               label="Рабочий номер телефона"/>
                        <Field name="org.email"
                               component={MaterialTextField}
                               label="Рабочий электронный адрес"/>
                        <Field name="org.activity"
                               select
                               component={MaterialTextField}
                               label="Род деятельности" >
                            {Activities.map((a, i) => <MenuItem key={i} value={a}>{a}</MenuItem>)}
                        </Field>
                    </Collapse>
                </Collapse>
                <SubmitButton label="Зарегистрироваться" />
            </form>
        );
    }
}

const RegisterForm = reduxForm({
    form: "register-form",
    initialValues: {
        "type": "NATURAL_PERSON"
    }
})(registerForm);

const loginForm = ({handleSubmit}) => (
    <form className="common-form" onSubmit={handleSubmit} autoComplete="off">
        <Field component={MaterialTextField}
               name="email"
               validate={validateEmail}
               placeholder="Электронный адрес"
               label="Электронный адрес" />
        <Field component={MaterialTextField}
               name="password"
               validate={required}
               type="password"
               label="Пароль" />
        <SubmitButton label="Войти" />
    </form>
);

const LoginForm = reduxForm({
    form: "login-form"
})(loginForm);

class Login extends React.Component {

    state = {
        value: 0
    };

    switchTab = (e, value) => {
        this.setState({ registerFormExtended: false }, () => this.setState({ value }))
    };


    render() {
        const { value } = this.state;
        const { onLogin, onRegister } = this.props;
        return (
            <Fade in={true}>
                <Paper className="welcome-paper">
                    <Tabs value={value} onChange={this.switchTab} centered >
                        <Tab label="Авторизация" icon={<LockOpenIcon />} />
                        <Tab label="Регистрация" icon={<FaceIcon />} />
                    </Tabs>
                    <SwipeableViews axis='x' index={value}>
                        <div dir="x" className="tab">
                            <LoginForm onSubmit={onLogin} />
                        </div>
                        <div dir="x" className="tab">
                            <RegisterForm onSubmit={onRegister} />
                        </div>
                    </SwipeableViews>
                </Paper>
            </Fade>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    onRegister: values =>
        agent.Auth.register(values)
            .then(res => dispatch({type: REGISTER, payload: res})),
    onLogin: ({email, password}) =>
        agent.Auth.login(email, password)
            .then(res => dispatch({type: LOGIN, payload: res}))
            .catch(err => {
                return Promise.reject(new SubmissionError(err.errors));
            }),
});

export default connect(null, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Welcome.js